import EventBus from '../../utils/EventBus';
import scrollToTarget from '../../utils/ScrollToTarget';

export default {
    props: {
        markerId: {
            type: String,
            default: '',
            required: true
        },
        mapElement: {
            type: String,
            default: '',
            required: true
        }
    },
    methods: {
        handleOnClick(event) {
            event.preventDefault();

            const map = document.getElementById(this.mapElement);
            const eventData = {markerId: this.markerId};

            // Check if map exists on page
            if(map !== null) {
                EventBus.$emit('MapLink:scrollStart', eventData);

                scrollToTarget(map, { animationTime: 0 }, () => {
                    EventBus.$emit('MapLink:scrollEnd', eventData);
                });
            }
        }
    }
};
